module.exports = __webpack_public_path__ + "img/3_105.18c8e3e7.png";